<!-- 账套管理 -->
<!-- 表单 -->
<template>
   <div class='page_content'>
      <div class="page_content_top">
         <div class="page_content_top_line">
            <!-- <el-button type="primary" size="mini" @click="actionSet(buttonValue)" v-for="(buttonValue,buttonKey) in buttonList" :key="buttonKey">
               {{buttonValue.jurName}}
            </el-button> -->

            <el-button type="primary" icon="el-icon-refresh" size="mini" @click="getPageInfo()">
               刷新
            </el-button>
         </div>
      </div>
      <el-card class="box-card" style="position: relative; overflow: hidden">
         <div class="page_content">
            <div class="page_content_top">
               <div class="page_content_top_line">
                  <h4 style="margin-top:0;">账套管理</h4>
               </div>
               <!-- <el-row style="margin: 20px 0">
                  <el-button type="primary" plain size="mini" @click="addAccount">新增</el-button>
                  <el-button type="primary" plain size="mini" @click="getAllAccountInfo">刷新</el-button>

               </el-row> -->
            </div>
            <div class="page_content_center">
               <el-form ref="'accountList' + index" label-width="100px" class="demo-ruleForm newForm" size="mini" v-for="(account,index) in accountList" :key="index">
                  <div style="margin-bottom:10px;">
                     <el-tag type="success" size="mini">账套{{(index+1)}}</el-tag>
                     <!-- <el-tag @click="delAccount(index)" type="danger" size="mini" style="cursor: pointer;margin-left:10px;">删除</el-tag> -->
                  </div>
                  <!--  :rules="[{required: true, message: field.label + '不能为空', trigger: ['blur', 'change']}]" -->
                  <el-row v-for="(field, i) in accountField" :key="i"  :gutter="20">
                           <el-col v-if="field.type != 2"  :span="12" >
                              <el-form-item :label="field.label + ':'" prop="field.field">
                                 <el-input v-if="field.type == 0"  :disabled="i == 0" v-model="accountList[index][field.field]" clearable></el-input>
                                 <el-select v-if="field.type == 1" v-model="accountList[index][field.field]" placeholder="请选择">
                                    <el-option
                                       v-for="item in options"
                                       :key="item.label"
                                       :label="item.label"
                                       :value="item.value">
                                    </el-option>
                                 </el-select>
                              </el-form-item>
                           </el-col>
                           <el-col v-if="field.type == 2" :span="24"  >
                              <el-form-item required :label="field.label + ':'">
                                 <el-input  autosize rows="5"  type="textarea" :disabled="i == 0" v-model="accountList[index][field.field]" clearable></el-input>
                              </el-form-item>
                           </el-col>
                           <el-col v-if="i == accountField.length - 1" :span="24">
                              <el-button style="margin-left:50%;" type="primary" plain size="mini" @click="updateAccount(index)">保存</el-button>
                           </el-col>
                     </el-row>
               </el-form>
            </div>
         </div>
         <el-dialog title="新增账套" :visible.sync="accountDia" width="700px">
            <el-form label-width="100px" class="demo-ruleForm" size="mini">
               <el-row :gutter="24">
                  <el-col :span="12" v-for="(field,i) in accountField" :key="i">
                     <el-form-item :label="field.label+':'" prop="field.field">
                        <el-input v-model="defaultAccount[field.field]" clearable></el-input>
                     </el-form-item>
                  </el-col>
               </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
               <el-button @click="accountDia = false">取 消</el-button>
               <el-button type="primary" @click="saveAccount()">确 定</el-button>
            </span>
         </el-dialog>

      </el-card>
   </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// import {mock} from "@/api/formList.js"
import Vue from "vue";
export default {
   //import引入的组件需要注入到对象中才能使用
   components: {},
   data() {
      //这里存放数据
      return {
         dialogFormVisible: false,
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "",
            actionType: 0, // 0新增，1修改
         },
         printform: {
            printName: "",
            printDesc: "",
            printContent: "",
         },
         options: [
            {
          value: 0,
          label: 'T+旧方案'
        }, 
        {
          value: 1,
          label: 'T+新方案'
        },
        {
          value: 2,
          label: 'U8'
           },
        {
          value: 3,
          label: '金蝶数据库'
        },
        {
          value: 4,
          label: '金蝶接口'
        },
        {
          value: 5,
          label: '基础数据库'
        },
        {
          value: 6,
          label: 'API接口'
        },
        {
          value:7,
          label: '金蝶星辰云'
        },
        {
          value:8,
          label: 'NC接口'
        },
      ],
         tableData: [],
         systemFormList: [],
         selectForm: "",
         drawer: false,
         formData: {},
         classifyInfo: [],
         classifyType: [],
         defaultParams: {
            label: "jurName",
            value: "jurId",
            children: [],
         },
         classifySelValue: "",
         showData: {},
         drawerTitle: "",
         ids: [],
         allDataList: [],
         printDataUrl: "",
         userData: [],
         reportmod: "",
         idParams: {},
         operType: 0,
         loading: false,
         accountField: [
            {
               field: "configId",
               label: "账套号",
               type:0
            },
            {
               field: "vtype",
               label: "账套类型",
               type:1
            },
            {
               field: "pramcontext",
               label: "参数",
               type:2
            },
            {
               field: "remark",
               label: "参数说明",
               type:2
            },
           
          
          

         ],
         rules: {
            // appKey: [
            //    { required: true, message: "请输入appKey", trigger: "blur" },
            // ],
            // appSecret: [
            //    { required: true, message: "请输入appSecret", trigger: "blur" },
            // ],
            // userName: [
            //    { required: true, message: "请输入用户名", trigger: "blur" },
            // ],
            // userPassword: [
            //    { required: true, message: "请输入密码", trigger: "blur" },
            // ],
            // configId: [
            //    { required: true, message: "请输入账套号", trigger: "blur" },
            // ],
            // serverUrl: [
            //    { required: true, message: "请输入服务器地址", trigger: "blur" },
            // ],
            // keyUrl: [
            //    { required: true, message: "请输入私钥地址", trigger: "blur" },
            // ],
         },
         defaultAccount: {
            appKey: "",
            appSecret: "",
            userName: "",
            userPassword: "",
            configId: "",
            serverUrl: "",
            keyUrl: "",
         },
         accountList: [],
         buttonList: [],
         accountDia: false,
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {},
   //方法集合
   methods: {
      // 新增账套
      // addAccount() {
      //     this.$refs.audio.currentTime = 0; //从头开始播放提示音
      //     this.$refs.audio.play(); //播放
      // },
      // 删除账套
      delAccount(index) {
         this.$confirm("此操作将永久删除该账套信息, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(() => {
               let params = {
                  ids: [this.accountList[index].configId],
               };
               return new Promise((resolve, reject) => {
                  this.$http.delAccountInfo(params).then((res) => {
                     if (res.status == 200) {
                        this.$message({
                           message: "删除成功",
                           type: "success",
                        });
                        this.getAllAccountInfo();
                     } else {
                        return this.$message({
                           message: res.message,
                           type: "error",
                        });
                     }
                     resolve();
                  });
               });
            })
            .catch(() => {
               this.$message({
                  type: "info",
                  message: "已取消删除",
               });
            });
      },
      // 动作集合
      actionSet(actionData) {
         switch (actionData.actionType) {
         	case 0:
         		// this.showStatus = true
         		// this.actionData = {
         		// 	cate: 0,
         		// 	formData: this.formDataList,
         		// 	oldData: '',
         		// 	orderId: '',
         		// 	printSouce: '',
         		// 	printJurId: ''
         		// }
                this.addAccount()
         		break;
         	// case 1:
         	// 	if (this.returnData.list.length <= 0) {
         	// 		if (!dataInfo) {
         	// 			this.$message({
         	// 				message: "暂无数据",
         	// 				type: "error",
         	// 			});
         	// 			return false;
         	// 		}
         	// 	}
         	// 	if (!this.returnData.list[this.selectedDataIndex]) {
         	// 		this.$message({
         	// 			message: "请先选择您要操作的数据",
         	// 			type: "error",
         	// 		});
         	// 		return false;
         	// 	}
         	// 	var dataInfo = this.returnData.list[this.selectedDataIndex];
         	// 	this.showStatus = true
         	// 	this.actionData = {
         	// 		cate: 1,
         	// 		formData: this.formDataList,
         	// 		oldData: dataInfo,
         	// 		orderId: dataInfo.id,
         	// 		printSouce: '',
         	// 		printJurId: ''
         	// 	}
         	// 	break;
         	// case 2:
         	// 	this.delDataAction();
         	// 	break;
         	// case 3:
         	// 	this.submitData();
         	// 	break;
         	// case 15:
         	// 	this.openFormDesign()
         	// 	break;
         }
      },
      // 保存账套
      saveAccount(defaultAccount) {
         // console.log(this.$refs[defaultAccount])
         // this.$refs[defaultAccount].validate((valid) => {
         //     if (valid) {

         //     } else {
         //         console.log('error submit!!');
         //         return false;
         //     }
         // });
         let params = this.defaultAccount;
         return new Promise((resolve, reject) => {
            this.$http.addAccountInfo(params).then((res) => {
               if (res.status == 200) {
                  this.$message({
                     message: "保存成功",
                     type: "success",
                  });
                  this.accountDia = false;
                  this.getAllAccountInfo();
               } else {
                  return this.$message({
                     message: res.message,
                     type: "error",
                  });
               }
               resolve();
            });
         });
      },
      // 修改配置信息
      updateAccount(index) {
         let params = this.accountList[index];
         return new Promise((resolve, reject) => {
            this.$http.updateAccountInfo(params).then((res) => {
               if (res.status == 200) {
                  this.$message({
                     message: "修改成功",
                     type: "success",
                  });
                  this.getAllAccountInfo();
               } else {
                  return this.$message({
                     message: res.message,
                     type: "error",
                  });
               }
               resolve();
            });
         });
      },
      // 新增账套
      addAccount() {
         for (let key in this.defaultAccount) {
            this.defaultAccount[key] = "";
         }
         this.accountDia = true;
         // this.accountList.push(this.defaultAccount)
      },
      // 获取全部账套信息
      getAllAccountInfo() {
         return new Promise((resolve, reject) => {
            this.$http.getAccountInfo().then((res) => {
               this.accountList = res.result;
               console.log(res);
               resolve();
            });
         });
      },
      submitForm(formName) {
         this.$refs[formName].validate((valid) => {
            if (valid) {
               alert("submit!");
            } else {
               console.log("error submit!!");
               return false;
            }
         });
      },
      resetForm(formName) {
         this.$refs[formName].resetFields();
      },
      // 获取按钮权限
      async getButtonList() {
         this.buttonList = await this.$common.getActionButton();
         
      },
// 获取数据列表
      async getPageInfo() {
         var pathId = parent.getMenuInfo(this.$route.path);
         let responseData = await this.$http.getJur({
            ids: [pathId.jurId],
         });
         if (responseData.status == 200) {
            this.pageShowData = responseData.result;
            this.formDataList = this.pageShowData.jurFormVoList;
            this.getAllAccountInfo();
            this.getButtonList();
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.getAllAccountInfo();
      this.getButtonList();
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {},
   beforeCreate() {}, //生命周期 - 创建之前
   beforeMount() {}, //生命周期 - 挂载之前
   beforeUpdate() {}, //生命周期 - 更新之前
   updated() {}, //生命周期 - 更新之后
   beforeDestroy() {}, //生命周期 - 销毁之前
   destroyed() {}, //生命周期 - 销毁完成
   activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style  scoped>
.el-tabs__content {
   height: 90% !important;
}
.el-card {
   min-height: 70vh;
   margin: 20px;
}
.el-tabs-box {
   margin-top: 20px;
}
/* .page_content_top_line {
    margin-top: 20px;
} */
.draw {
   padding: 20px;
}
.el-tabs__content {
   min-height: 60vh;
}
.el-select {
   width: 100%;
}
::v-deep #addNew .el-table__row td:last-child {
   border: none;
}
/* ::v-deep#addNew .el-table {
    max-height: 70vh !important;
    width: 100%;
    overflow-y: auto;
    overflow-x: auto;
}
::v-deep#addNew .el-table__body-wrapper {
    max-height: 100vh !important;
} */
.newForm {
   border: 1px solid #efefef;
   padding: 10px;
   margin-bottom: 10px;
}
.btns {
   display: flex;
   justify-content: center;
}
</style>
